enum DynamicGeofenceUnit {
  Meters = 'meters',
  Minutes = 'minute',
}

export default DynamicGeofenceUnit;
